import React, { Fragment } from 'react'
import { InventoryCheck } from '../entities/InventoryCheck'
import { Box, Button, Grid, TextField } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { updateInventoryCheck } from '../api'
import { utcIntialDate } from '../../../utils/dateHelper'
import { DateTime } from 'luxon'
import { Filter } from '../../../components/_WMS/FilterComponent'

interface EditInventoryCheckModalProps {
  inventoryCheck: InventoryCheck
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal: () => void
  requestInventoryCheck: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

export const validationSchema = Yup.object().shape({
  LPN: Yup.string()
    .trim()
    .min(1, 'Se requiere al menos un caracter')
    .required('LPN/Tote es obligatorio')
})

export const EditInventoryCheckModal: React.FC<
  EditInventoryCheckModalProps
> = ({
  inventoryCheck,
  handleSnackbar,
  handleCloseModal,
  requestInventoryCheck
}) => {
  const handleSubmit = async (values: any) => {
    const finalValues: InventoryCheck = {
      ...values,
      promiseDate: utcIntialDate(values.promiseDate as string)
    }

    await updateInventoryCheck(values.inventoryCheckId, finalValues)
      .then(() => {
        requestInventoryCheck()
        handleSnackbar('Entidad editada correctamente', true)
        handleCloseModal()
      })
      .catch((error) => {
        handleSnackbar('Error al editar: ' + error, false)
      })
  }

  // se combierte la fecha, al formato aceptado por el componente
  const convertToDateInputFormat = (
    dateTime: string | Date | undefined
  ): string => {
    if (!dateTime) {
      return ''
    }

    const date =
      typeof dateTime === 'string'
        ? DateTime.fromISO(dateTime) // Parsear desde un ISO string
        : DateTime.fromJSDate(dateTime) // Parsear desde un objeto Date

    return date.toFormat('yyyy-MM-dd') // Convertir al formato YYYY-MM-DD
  }

  const transformedInventoryCheck = {
    ...inventoryCheck,
    promiseDate: convertToDateInputFormat(inventoryCheck.promiseDate)
  }

  return (
    <Fragment>
      <Formik
        initialValues={transformedInventoryCheck}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            await handleSubmit(values)
          } catch (error) {
          } finally {
            setSubmitting(false)
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form autoComplete='off'>
            <Grid container direction='row' spacing={2}>
              <Grid item xs={12} sm={6}>
                <Field name='inventoryCheckId'>
                  {({ field }: any) => (
                    <TextField
                      {...field}
                      fullWidth
                      label='ID'
                      variant='outlined'
                      InputProps={{ readOnly: true }}
                    />
                  )}
                </Field>
              </Grid>
              <Grid item xs={12} sm={6}></Grid>
              <Grid item xs={12} sm={6}>
                <Field name='tag'>
                  {({ field }: any) => (
                    <TextField
                      {...field}
                      fullWidth
                      label='Tag'
                      variant='outlined'
                    />
                  )}
                </Field>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field name='promiseDate'>
                  {({ field }: any) => (
                    <TextField
                      {...field}
                      fullWidth
                      label='Fecha de Compromiso'
                      type='date'
                      variant='outlined'
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  )}
                </Field>
              </Grid>
            </Grid>
            <Grid container style={{ marginTop: 16 }}>
              <Grid item xs={12}>
                <Box display='flex' justifyContent='center'>
                  <Button
                    variant='contained'
                    color='primary'
                    type='submit'
                    disabled={isSubmitting}
                    size='large'
                  >
                    Guardar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}
